import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import "./Footer.css";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col
              md={6}
              className="text-lg-left text-md-left text-sm-center text-center footerFont"
            >
              {/* change by laxmi------------------------ */}
              {/* Powered by
              <a
                href="http://globaltrendz.com/"
                target="_blank"
                style={{ color: "#ab3d00" }}
              >
                Global Trendz
              </a> */}
              Powered by
              <a href="http://globaltrendz.com/" target="_blank">
                <span style={{ color: "#ab3d00" }}> Global Trendz</span>
              </a>
            </Col>
            <Col md={6}>
              {/*change by laxmi -add footerFont class remove text-sm-right and d-none from class for phn view and tab view------------------- */}

              {/* <div className="text-sm-right d-none d-sm-block"> */}
              {/* <div className="d-none d-sm-block text-lg-right text-md-right text-sm-center text-center"> */}
              <div className="d-block d-sm-block text-lg-right text-md-right text-sm-center text-center footerFont">
                {new Date().getFullYear()} © Shanthi Jewellers. All Rights
                Reserved.
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
